module.exports = __webpack_public_path__ + "img/Fumin_Shen@2x.06908478.png";